(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Raci', Raci);

    Raci.$inject = ['$resource'];

    function Raci ($resource) {
        var resourceUrl =  'api/racis/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
